import { create } from "zustand";
import { Texture } from "three";

const initialState = {
  showEnclosure: false,
  showFoam: false,
  showComplianceProcessor: true,
  showEncryptedComm: true,
  showOfflinePower: false,
  fanStates: [false, false, false],
  playBreachAnimation: false,
  playDisableAnimation: false,
  isRadioActive: false,
  isDieCoverOpen: false,
  isUnplugged: false,
  isBreached: false,
  currentCamera: "enclosure",
  highlightedParts: [],
  texturesCache: [],
  isFinishedLoadingTextures: false,
  texturesPreloadedOnScene: false,
  disableStartAt: 0,
};

const useStore = create((set) => ({
  ...initialState,
  togglePower: (isUnplugged: any) =>
    set((state: any) => ({
      ...state,
      isUnplugged,
    })),
  toggleFan: (indexes: number[]) =>
    set((state: any) => ({
      ...state,
      fanStates: indexes.map((i) => !state.fanStates[i]),
    })),
  toggleRadio: () =>
    set((state: any) => ({
      ...state,
      isRadioActive: !state.isRadioActive,
    })),
  toggleDieCover: () =>
    set((state: any) => ({
      ...state,
      isDieCoverOpen: !state.isDieCoverOpen,
    })),
  togglePlayBreach: () =>
    set((state: any) => ({
      ...state,
      playBreachAnimation: !state.playBreachAnimation,
    })),
  toggleSelfDisable: () =>
    set((state: any) => ({
      ...state,
      playDisableAnimation: !state.playDisableAnimation,
      disableStartAt: Date.now(),
    })),

  switchCamera: (cameraKey: string) =>
    set((state: any) => ({
      ...state,
      currentCamera: cameraKey,
    })),
  setShowFoam: (showFoam: boolean) =>
    set((state: any) => ({
      ...state,
      showFoam,
    })),
  setHighlightedParts: (highlightedParts: string[]) =>
    set((state: any) => ({
      ...state,
      highlightedParts,
    })),
  setIsBreached: (isBreached: boolean) =>
    set((state: any) => ({
      ...state,
      isBreached,
    })),
  setTexturesCache: (texturesCache: Texture[]) =>
    set((state: any) => ({
      ...state,
      texturesCache,
    })),
  setTexturesPreloadedOnScene: (texturesPreloadedOnScene: boolean) =>
    set((state: any) => ({
      ...state,
      texturesPreloadedOnScene,
    })),

  setShowEnclosure: (showEnclosure: boolean) =>
    set((state: any) => ({
      ...state,
      showEnclosure,
    })),
  setShowComplianceProcessor: (showComplianceProcessor: boolean) =>
    set((state: any) => ({
      ...state,
      showComplianceProcessor,
    })),
  setShowEncryptedComm: (showEncryptedComm: boolean) =>
    set((state: any) => ({
      ...state,
      showEncryptedComm,
    })),
  setShowOfflinePower: (showOfflinePower: boolean) =>
    set((state: any) => ({
      ...state,
      showOfflinePower,
    })),
  setIsFinishedLoadingTextures: (isFinishedLoadingTextures: boolean) =>
    set((state: any) => ({
      ...state,
      isFinishedLoadingTextures,
    })),
}));

export default useStore;
